import { Card } from "@/components/ui/Card";
import { type ReactNode } from "react";

interface StatsCardProps {
  label: string;
  value: string | number;
  icon: ReactNode;
}

export function StatsCard({ label, value, icon }: StatsCardProps) {
  return (
    <Card className="p-5">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-grey font-body">{label}</p>
          <p className="text-2xl font-display font-bold mt-1">{value}</p>
        </div>
        <div className="p-2 rounded-lg bg-cream">{icon}</div>
      </div>
    </Card>
  );
}
